import { useIntl } from "react-intl"

import { BookedAppointment } from "reducers/conversations/conversations.reducer"

import BookedErrandsList from "./BookedErrandsList"
import OngoingErrandsList from "./OngoingErrandsList"
import RequestsList from "./RequestsList"

import styles from "./AssignedConversationList.module.scss"

interface OngoingConversationListProps {
  ongoing: BookedAppointment[]
  booked: BookedAppointment[]
  requests: BookedAppointment[]
}

const OngoingConversationList = ({ ongoing, booked, requests }: OngoingConversationListProps) => {
  const intl = useIntl()
  return (
    <>
      {requests && requests.length > 0 && <RequestsList conversations={requests} />}
      <div className={styles.listContainer}>
        <OngoingErrandsList
          title={intl.formatMessage({ id: "label.overview.ongoing_errands" })}
          conversations={ongoing}
        />
      </div>
      {booked.length > 0 && (
        <>
          <div className={styles.divider}></div>
          <div className={styles.listContainer}>
            <BookedErrandsList
              title={intl.formatMessage({ id: "label.overview.booked_errands" })}
              conversations={booked}
            />
          </div>
        </>
      )}
    </>
  )
}

export default OngoingConversationList
